import React from 'react'
import { Modal } from 'react-bootstrap'
import { i18nTranslate } from 'src/utils'
import './styles.scss'

/**
 * DrawerModal component.
 * Renders a modal dialog with custom styling.
 * @param {Object} props
 * @param {boolean} props.show - Whether to show the modal
 * @param {Function} props.onHide - Callback when modal is hidden
 * @param {Function} props.renderView - Renders modal content
 */
class DrawerModal extends React.Component {
  render() {
    const {
      show = false,
      onHide = function () {},
      renderView = function () {},
      propsValue = {},
      showCloseButton = true,
      customClass = '',
      title = '',
      label = 'edit subscription',
      testId = 'qa-subscription-edit-modal-header-wrapper',
    } = this.props

    const modalTitleId = 'drawer-modal-title'

    return (
      <div>
        <Modal
          show={show}
          tabIndex={0}
          onHide={() => onHide()}
          dialogClassName={`modal-dialog-custom-right drawer-model-wrapper ${customClass}`}
          aria-label={label}
          aria-labelledby={modalTitleId}>
          <Modal.Header data-testid={testId} closeButton={showCloseButton}>
            {/* Avoid Modal.Title here to ensure semantic HTML */}
            <h1 id={modalTitleId} className="modal-title" tabIndex={0}>
              {title
                ? title
                : i18nTranslate(
                    'subscription.drawerPopupTitle',
                    'Add to Subscription'
                  )}
            </h1>
          </Modal.Header>

          <Modal.Body>{renderView(propsValue)}</Modal.Body>
        </Modal>
      </div>
    )
  }
}

export default DrawerModal
export { DrawerModal }
